import React, { useContext } from 'react';
import context from '../context';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { Section } from '../styled-components';
import { WhatsAppOutlined } from '@ant-design/icons';

const SectionCustom = styled(Section)` 
  border: 1px solid #D8D8D8;
  border-left: none;
  border-right: none;
  padding: 2rem 0;
`;

const Title = styled.p`
  margin: 0 0 1rem 0;
  @media(min-width:768px){
    margin-bottom: 0;
  }
`;

/* Botón WhatsApp */
const WhatsAppButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: .6rem;
  width: 100%;                 /* full width como "block" */
  padding: .8rem 1.25rem;
  border-radius: 999px;
  background: #06d755;
  color: #fff !important;
  font-weight: 700;
  letter-spacing: .3px;
  text-decoration: none !important;
  transition: filter .2s ease, transform .06s ease;

  &:hover { filter: brightness(1.05); }
  &:active { transform: translateY(1px); }

  .anticon { font-size: 1.2rem; }
`;

export default () => {
  const state = useContext(context);

  // fallback seguro si no viene móvil
  const phone = (state?.movil || '').replace(/\s/g,'');
  const waText = encodeURIComponent(
    'Hola, estoy visitando su sitio web y quisiera comunicarme con ustedes.'
  );

  return (
    <SectionCustom>
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={9}>
            <Title>{state.about.ubication.title}</Title>
          </Col>

          <Col xs={12} md={3} className="mt-3 mt-md-0">
            <WhatsAppButton
              title="Enviar WhatsApp"
              rel="noopener"
              target="_blank"
              href={`https://api.whatsapp.com/send?phone=${phone}&text=${waText}`}
            >
              <WhatsAppOutlined />
              Contactar
            </WhatsAppButton>
          </Col>
        </Row>
      </Container>
    </SectionCustom>
  );
};